import * as React from "react";
import CustomSelect from "../CustomSelect";
import IStaticDataValue from "../../../../common/models/IStaticDataValue";
import TypeAhead, {TypeAheadElement} from "../TypeAhead";
import { isEmpty as _isEmpty } from "lodash";
import LocalStorageUtils from "../../utils/LocalStorageUtils";
import {SectionContext} from "../../utils/EventTrackerConstants";

interface InputWithDropDownComponentProps {
    name?: string
    widgetName?: string
    inputValue: string,
    dropdownValue: string,
    dropdownValues: IStaticDataValue[],
    onTextInputChange: (e: any) => void,
    onDropdownChange: (item: string) => void,
    inputPlaceholder?: string,
    dropdownPlaceholder?: string,
    inputOptions?: string[],
    flow?: string
}

export default class InputWithDropDownComponent extends React.Component<InputWithDropDownComponentProps> {
    static contextType = SectionContext;
    handleDropDownValue = (item: string, key?: string) => {
        LocalStorageUtils.setClickEvents({ value: item, field: this.props.name, widget: this.props.widgetName, section: this.context, flow: this.props.flow })
        this.props.onDropdownChange(item)
    }

    handleInputChange = (input: string): Promise<{ options: TypeAheadElement[] }> => {
        this.props.onTextInputChange(input);
        const inputSuggestions: TypeAheadElement[] = [];
        if (!_isEmpty(this.props.inputOptions)) {
            this.props.inputOptions.filter((suggestion: string) => !_isEmpty(suggestion.match(input))).map((option: string, index: number) => {
                inputSuggestions.push({
                    value: option,
                    label: option
                })
            })
        }
        return Promise.resolve({
            options: inputSuggestions
        })
    }

    handleInputOptionSelect = (elem: TypeAheadElement) => this.props.onTextInputChange(elem.value)

    render() {
        return (
            <div className={"input-dropdown-container"}>
                <div className={"input-wrapper"}>
                    <TypeAhead
                        name={"TypeAhead"}
                        widgetName={this.props.widgetName}
                        value={this.props.inputValue || ""}
                        placeholder={"unit"}
                        onTypeAheadChange={this.handleInputChange}
                        onTypeAheadSelect={this.handleInputOptionSelect}
                    />
                    {"|"}
                    <CustomSelect dropdownValues={this.props.dropdownValues || [
                        {displayValue: "ML", internalValue: "ml"},
                        {displayValue: "G", internalValue: "g"}
                    ]} selectedValue={this.props.dropdownValue || ""} defaultValue={this.props.dropdownPlaceholder} updateDropdownValue={this.handleDropDownValue} id={""} className={""}/>
                </div>
            </div>
        )
    }
}